/// <reference types="w3c-web-usb" />
import { useEffect, useState } from "react";
import api from "../utils/api";
import { API_ENDPOINTS } from "../utils/urls";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  Printer,
  Text,
  Row,
  Line,
  Br,
  Cut,
  render,
} from "react-thermal-printer";
import SendLinkOverlay from "../components/SendLinkOverlay";
export default function Orders() {
  const [orders, setOrders] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalOrders, setTotalOrders] = useState(10);
  const [userData, setUserData] = useState<any>();
  const [expandedOrders, setExpandedOrders] = useState<{
    [key: string]: boolean;
  }>({});
  const [loading, setLoading] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [orderIdToPay, setOrderIdToPay] = useState("");

  const ORDERS_PER_PAGE = 10;
  const totalPages = Math.ceil(totalOrders / ORDERS_PER_PAGE);

  const userInfo = async () => {
    try {
      const getInfo = await api.get(API_ENDPOINTS.USER.GET_USER_PRINT_DETAILS);
      setUserData(getInfo.data.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };

  useEffect(() => {
    userInfo();
  }, []);

  const getDashboardData = async () => {
    try {
      const res = await api.get(
        API_ENDPOINTS.ORDERS.GET_ORDERS + `?page=${page}`
      );
      setTotalOrders(res.data.count || 10);
      setOrders(res.data.data || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Failed to fetch orders");
    }
  };

  const toggleExpand = (orderId: string) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  const handleStatusUpdate = async (billingId: string) => {
    try {
      await api.put(
        `${API_ENDPOINTS.ORDERS.GET_ORDERS}?billingId=${billingId}`,
        {
          status: "completed",
        }
      );
      toast.success("Order marked as completed");
      getDashboardData();
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  const handleTogglePaid = async (billingId: string, paidStatus: boolean) => {
    try {
      await api.put(
        `${API_ENDPOINTS.ORDERS.GET_ORDERS}?billingId=${billingId}`,
        {
          paid: paidStatus,
        }
      );
      toast.success("Order marked as paid");
      getDashboardData();
    } catch (err) {
      toast.error("Failed to update paid status");
    }
  };

  useEffect(() => {
    getDashboardData();
  }, [page]);

  const splitTextToLines = (text: string, maxLength: number): string[] => {
    const words = text.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
      if ((currentLine + word).length <= maxLength) {
        currentLine += word + " ";
      } else {
        lines.push(currentLine.trim());
        currentLine = word + " ";
      }
    }

    if (currentLine.trim()) {
      lines.push(currentLine.trim());
    }

    return lines;
  };

  const handlePrint = async (order: any) => {
    try {
      console.log(order, "Order");
      {
        order.items.map((item: any) => {
          if (item.variant?.inventory?.name !== undefined) {
            item.name =
              item.variant?.inventory?.name + " - " + item.variant?.variantName;
          } else {
            item.name = item.addOn.name;
          }
        });
      }
      const data = await render(createReceiptComponent(order));
      await sendToPrinter(data);
    } catch (err: any) {
      console.log("Error While Printing" + err.message);
      toast.error(
        "Failed To Print, Please Use Zadig to install WinUsb or Contact Us"
      );
    }
  };

  const createReceiptComponent = (order: any) => {
    const totalAfterDiscount =
      order.amountBeforeDiscountandGst -
      (order.discountPercentage > 0
        ? (order.amountBeforeDiscountandGst * order.discountPercentage) / 100
        : order.discountAmount);
    const cgst = totalAfterDiscount * 0.025;
    const sgst = totalAfterDiscount * 0.025;

    return (
      <Printer type="epson" width={32} characterSet="pc437_usa">
        <Text align="center" bold={true}>
          {userData.storeName || userData.username}
        </Text>
        {splitTextToLines(userData.address || "", 32).map((line, idx) => (
          <Text key={idx} align="center">
            {line}
          </Text>
        ))}
        <Text align="center">{userData.phonenumber}</Text>
        <Text align="center">{userData.GST}</Text>
        <Br />
        <Line />
        {order.items.map((item: any, idx: any) => (
          <Row
            key={idx}
            left={`${item.name} x ${item.quantity}`}
            right={`Rs ${(item.price * item.quantity).toFixed(2)}`}
          />
        ))}
        <Line />

        <Row left="Subtotal" right={`Rs ${order.amountBeforeDiscountandGst}`} />

        {order.discountAmount > 0 && (
          <Row left="Discount" right={`-Rs ${order.discountAmount}`} />
        )}
        {order.discountPercentage > 0 && (
          <Row left="Discount %" right={`${order.discountPercentage}%`} />
        )}

        <Row left="C GST (2.5%)" right={`Rs ${cgst.toFixed(2)}`} />
        <Row left="S GST (2.5%)" right={`Rs ${sgst.toFixed(2)}`} />

        <Line />
        <Row left="Final Total" right={`Rs ${order.totalAmount}`} />
        <Br />
        <Text align="center">Thank you! Visit again.</Text>
        <Cut />
      </Printer>
    );
  };

  const sendToPrinter = async (data: Uint8Array) => {
    const savedDevice = JSON.parse(
      localStorage.getItem("selectedPrinter") || "{}"
    );

    let device;
    if (
      savedDevice.vendorId &&
      savedDevice.productId &&
      savedDevice.serialNumber
    ) {
      try {
        device = await navigator.usb.requestDevice({
          filters: [
            {
              vendorId: savedDevice.vendorId,
              productId: savedDevice.productId,
            },
          ],
        });
      } catch {
        device = null;
      }
    }

    if (!device) {
      device = await navigator.usb.requestDevice({ filters: [{}] });
      localStorage.setItem(
        "selectedPrinter",
        JSON.stringify({
          vendorId: device.vendorId,
          productId: device.productId,
          serialNumber: device.serialNumber,
        })
      );
    }

    await device.open();
    await device.selectConfiguration(1);
    await device.claimInterface(0);

    const endpoint =
      device?.configuration?.interfaces[0].alternates[0].endpoints.find(
        (e) => e.direction === "out"
      )?.endpointNumber || 3;

    await device.transferOut(endpoint, data);
    await device.close();
  };

  return (
    <div className="min-h-screen flex flex-col p-8">
      <Navbar />
      <div className="p-8 flex-grow">
        <h1 className="text-2xl font-bold mb-4">Your Orders</h1>
        {orders.length === 0 ? (
          <p>No orders found.</p>
        ) : (
          orders.map((order) => (
            <div
              key={order.billingId}
              className="bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-6 mb-6"
            >
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
                {/* Left: Order Summary */}
                <div className="flex-1 grid grid-cols-2 gap-y-1 gap-x-6 text-sm">
                  <p>
                    <span className="font-semibold text-gray-700">
                      Order ID:
                    </span>{" "}
                    {order.billingId}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-700">Total:</span>{" "}
                    ₹{order.totalAmount}
                  </p>
                  {order.discountAmount > 0 && (
                    <p>
                      <span className="font-semibold text-gray-700">
                        Discount:
                      </span>{" "}
                      ₹{order.discountAmount}
                    </p>
                  )}
                  {order.discountPercentage > 0 && (
                    <p>
                      <span className="font-semibold text-gray-700">
                        Discount %:
                      </span>{" "}
                      {order.discountPercentage}%
                    </p>
                  )}
                  <p className="flex gap-2 items-center">
                    <button
                      className="bg-blue-600 text-white px-2 py-1 rounded text-xs"
                      onClick={() => {
                        setShowOverlay(true);
                        setOrderIdToPay(order.billingId);
                        setLoading(true);
                      }}
                      disabled={showOverlay}
                    >
                      {loading ? "Processing..." : "Send Payment Link"}
                    </button>
                    <button
                      className="bg-blue-600 text-white px-2 py-1 rounded text-xs"
                      disabled={showOverlay || loading || true}
                    >
                      {loading ? "Processing..." : "Pay Now"}
                    </button>
                  </p>
                  <p>
                    <span className="font-semibold text-gray-700">
                      Payment:
                    </span>{" "}
                    {order.paymentMethod}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-700">
                      Created:
                    </span>{" "}
                    {new Date(order.createdAt).toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </p>
                </div>

                {/* Right: Status + Buttons */}
                <div className="grid grid-cols-3 gap-4 w-full sm:w-auto items-start">
                  {/* Column 1: Status + Paid */}
                  <div className="flex flex-col gap-2">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium text-center ${
                        order.status === "completed"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {order.status}
                    </span>
                    <span
                      className={`px-2 py-0.5 text-xs font-semibold rounded text-center ${
                        order.paid
                          ? "bg-green-200 text-green-800"
                          : "bg-red-200 text-red-800"
                      }`}
                    >
                      {order.paid ? "Paid" : "Unpaid"}
                    </span>
                  </div>

                  {/* Column 2: Checkbox + Mark Completed */}
                  <div className="flex flex-col gap-2">
                    <label className="flex items-center gap-2 text-sm text-gray-700">
                      <input
                        type="checkbox"
                        checked={order.paid}
                        onChange={() =>
                          handleTogglePaid(order.billingId, !order.paid)
                        }
                      />
                      Paid
                    </label>
                    {order.status === "pending" && (
                      <button
                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-md text-sm shadow"
                        onClick={() => handleStatusUpdate(order.billingId)}
                      >
                        Mark Completed
                      </button>
                    )}
                  </div>

                  <div className="flex flex-col gap-2">
                    <button
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                      onClick={() => toggleExpand(order.billingId)}
                    >
                      {expandedOrders[order.billingId]
                        ? "Hide Details"
                        : "Show Details"}
                    </button>
                    <button
                      className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-md text-sm shadow"
                      onClick={() => handlePrint(order)}
                    >
                      Print
                    </button>
                  </div>
                </div>
              </div>

              {/* Items Section */}
              {expandedOrders[order.billingId] && (
                <div className="mt-6 border-t pt-4">
                  <h2 className="text-lg font-semibold mb-3">
                    Items in this order:
                  </h2>
                  <div className="grid gap-4 sm:grid-cols-2">
                    {order.items.map((item: any) => {
                      let name = "";
                      if (item.variant?.inventory?.name !== undefined) {
                        name =
                          item.variant?.inventory?.name +
                          " - " +
                          item.variant?.variantName;
                      } else {
                        name = item.addOn.name;
                      }

                      return (
                        <div
                          key={item.billingItemId}
                          className="bg-gray-50 border rounded-lg p-4"
                        >
                          <p className="font-medium">{name}</p>
                          <p className="text-sm text-gray-600">
                            Qty: {item.quantity}
                          </p>
                          <p className="text-sm text-gray-600">
                            Price: ₹{item.price}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
        <div className="flex justify-center mt-4 gap-2 flex-wrap">
          {/* Prev Button */}
          <button
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition-colors"
            onClick={() => setPage((prev) => prev - 1)}
            disabled={page === 1}
          >
            Prev
          </button>

          {(() => {
            const pages: (number | string)[] = [];

            if (totalPages <= 7) {
              // If total pages is 7 or less, show all pages
              for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
              }
            } else {
              // Always show first page
              pages.push(1);

              if (page <= 4) {
                // Near the beginning: show 1, 2, 3, 4, 5, ..., last
                for (let i = 2; i <= 5; i++) {
                  pages.push(i);
                }
                pages.push("...");
                pages.push(totalPages);
              } else if (page >= totalPages - 3) {
                // Near the end: show 1, ..., last-4, last-3, last-2, last-1, last
                pages.push("...");
                for (let i = totalPages - 4; i <= totalPages; i++) {
                  pages.push(i);
                }
              } else {
                // In the middle: show 1, ..., current-1, current, current+1, ..., last
                pages.push("...");
                for (let i = page - 1; i <= page + 1; i++) {
                  pages.push(i);
                }
                pages.push("...");
                pages.push(totalPages);
              }
            }

            return pages.map((num, idx) =>
              typeof num === "string" ? (
                <span key={`ellipsis-${idx}`} className="px-2 py-1 text-gray-500">
                  {num}
                </span>
              ) : (
                <button
                  key={num}
                  className={`px-3 py-1 rounded transition-colors ${
                    page === num 
                      ? "bg-blue-600 text-white hover:bg-blue-700" 
                      : "bg-gray-200 hover:bg-gray-300"
                  }`}
                  onClick={() => setPage(num)}
                >
                  {num}
                </button>
              )
            );
          })()}

          {/* Next Button */}
          <button
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition-colors"
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      </div>
      {showOverlay && (
        <SendLinkOverlay
          onClose={() => {
            setShowOverlay(false);
            setLoading(false);
            setOrderIdToPay("");
          }}
          billingId={orderIdToPay}
        />
      )}
      <Footer />
    </div>
  );
}
